<template>
    <div v-if="quote.HasError != true" :class="{ 'finance-quote__quote': true, 'personal': modified }">
        <div class="finance-quote__quote-key"><span class="value">{{ numberOfPayments }}</span> Monthly Payments</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.AllInclusiveRegularPayment, 2) }}</div>

        <div class="finance-quote__quote-key">Customer Cash Deposit</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.CashDeposit, 2) }}</div>

        <div v-if="depositContribution > 0" class="finance-quote__quote-key">{{ brandName }} Deposit Contribution</div>
        <div v-if="depositContribution > 0" class="finance-quote__quote-value">&pound;{{ numberFormat(depositContribution,
            2) }}</div>

        <template v-if="retailPrice != cashPrice">
            <div class="finance-quote__quote-key">Vehicle Price (OTR)</div>
            <div class="finance-quote__quote-value">&pound;{{ numberFormat(retailPrice, 2) }}</div>
            <div v-if="governmentGrant > 0" class="finance-quote__quote-key">Government Grant</div>
            <div v-if="governmentGrant > 0" class="finance-quote__quote-value">&pound;{{ numberFormat(governmentGrant, 2) }}
            </div>
            <div class="finance-quote__quote-key">Vehicle Selling Price</div>
            <div class="finance-quote__quote-value">&pound;{{ numberFormat(cashPrice, 2) }}</div>
        </template>

        <template v-else>
            <div class="finance-quote__quote-key">Vehicle Price</div>
            <div class="finance-quote__quote-value">&pound;{{ numberFormat(cashPrice, 2) }}</div>
        </template>

        <div class="finance-quote__quote-key">
            {{ brandPCPFinanceName }} Price
            <span v-if="roadsideAssistance > 0" class="smallText">Including &pound;{{ roadsideAssistance }} Roadside
                Assistance</span>
        </div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.TotalPrice, 2) }}</div>

        <div v-if="quote.Quote.PartExchange" class="finance-quote__quote-key">Part-exchange Guide Price</div>
        <div v-if="quote.Quote.PartExchange" class="finance-quote__quote-value">&pound;{{
            numberFormat(quote.Quote.PartExchange, 2) }}</div>

        <div class="finance-quote__quote-key">Amount Financed</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.Balance, 2) }}</div>

        <div class="finance-quote__quote-key">Optional Final Payment To Buy</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(finalPayment, 2) }}</div>

        <div class="finance-quote__quote-key">Credit Facility Fee<br /><span class="smallText">Payable With 1st
                Payment</span></div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(fees, 2) }}</div>

        <div class="finance-quote__quote-key">Term Of Agreement</div>
        <div class="finance-quote__quote-value">{{ quote.Quote.Term }} months</div>

        <div class="finance-quote__quote-key">Total Charge For Credit</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.TotalChargeForCredit, 2) }}</div>

        <div class="finance-quote__quote-key">Total Amount Of Credit</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.AmountOfCredit, 2) }}</div>

        <div class="finance-quote__quote-key">Total Amount Payable</div>
        <div class="finance-quote__quote-value">&pound;{{ numberFormat(quote.Quote.TotalAmountPayable, 2) }}</div>

        <div class="finance-quote__quote-key">Fixed Rate of Interest</div>
        <div class="finance-quote__quote-value"> {{ numberFormat(quote.Quote.RateOfInterest, 2) }} %</div>

        <div v-if="modified" class="finance-quote__quote-key">APR</div>
        <div v-else class="finance-quote__quote-key">Representative APR</div>
        <div class="finance-quote__quote-value"> {{ numberFormat(quote.Quote.Apr, 2) }} % APR</div>

        <div class="finance-quote__quote-key">Excess Mileage Charge</div>
        <div class="finance-quote__quote-value"> {{ numberFormat(quote.Quote.ExcessMileageRate, 0) }} pence per mile</div>

        <div class="finance-quote__quote-key">Annual Mileage</div>
        <div class="finance-quote__quote-value"> {{ numberFormat(quote.Quote.AnnualMileage, 0) }} miles</div>
    </div>
</template>

<script>
import numberFormat from '../../../api/NumberFormat';

export default {
    props: {
        quote: {
            required: true,
        },
        loading: {
            required: true,
        },
        repExample: {
            default: false,
        },
        brandPCPFinanceName: {
            required: true,
        },
        vehicle: {
            required: true,
        }
    },
    methods: {
        numberFormat(num, decimals) {
            return numberFormat(num, decimals);
        },
    },
    computed: {
        manufacturer() {
            return this.vehicle.manufacturer.toLowerCase();
        },
        brandName() {
            if (this.manufacturer == 'peugeot') {
                return 'Peugeot';
            }
            if (this.manufacturer == 'citroen') {
                return 'Citroen';
            }
            if (this.manufacturer == 'vauxhall') {
                return 'Vauxhall';
            }
            if (this.manufacturer == 'ds') {
                return 'DS';
            }
            if (this.manufacturer == 'ds automobiles') {
                return 'DS';
            }
            if (this.manufacturer == 'fiat') {
                return 'Fiat';
            }
            if (this.manufacturer == 'abarth') {
                return 'Abarth';
            }
            return 'Stellantis &You UK';
        },
        modified() {
            if (this.repExample) {
                return false;
            }
            return this.$store.state.FinanceParameters.modified;
        },
        numberOfPayments() {
            const paymentCount = this.quote.Quote.Payments.length || 0;
            if (paymentCount == 0) {
                if (this.quote.Quote.Term) {
                    return quote.Quote.Term;
                }
                return 0;
            }
            if (paymentCount == 1 && this.quote.Quote.Payments && this.quote.Quote.Payments[0] && this.quote.Quote.Payments[0].NumberOfPayments) {
                return parseInt(this.quote.Quote.Payments[0].NumberOfPayments);
            }
            let numberOfPayments = 0;
            for (let index = 0, len = (paymentCount - 1); index < len; index++) {
                if (this.quote.Quote.Payments[index].NumberOfPayments) {
                    numberOfPayments = numberOfPayments + parseInt(this.quote.Quote.Payments[index].NumberOfPayments);
                }
            }
            return numberOfPayments;
        },
        finalPayment() {
            if (typeof this.quote.Quote.Payments[(this.quote.Quote.Payments.length - 1)] !== 'undefined') {
                return parseFloat(this.quote.Quote.Payments[(this.quote.Quote.Payments.length - 1)].Amount);
            }
            return 0;
        },
        fees() {
            if (typeof this.quote.Quote.Fees[0] !== 'undefined') {
                return parseFloat(this.quote.Quote.Fees[0].Amount);
            }
            return 0;
        },
        depositContribution() {
            if (typeof this.quote.Quote.DepositContribution !== 'undefined') {
                return parseFloat(this.quote.Quote.DepositContribution);
            }
            if (typeof this.quote.Quote.DepositContributions == 'undefined') {
                return 0.00;
            }
            let depCon = 0.00;
            $.each(this.quote.Quote.DepositContributions, function (NotificationsKey, FinanceNotification) {
                if (typeof FinanceNotification.Amount !== 'undefined') {
                    depCon += parseFloat(FinanceNotification.Amount);
                }
            });

            return depCon;
        },
        governmentGrant() {
            if (typeof this.quote.Quote.CashPriceDiscounts == 'undefined' || this.quote.Quote.CashPriceDiscounts.length == 0) {
                return 0;
            }
            let governmentGrant = 0;
            for (let i = 0, len = this.quote.Quote.CashPriceDiscounts.length; i < len; i++) {
                if (this.quote.Quote.CashPriceDiscounts[i].Name && this.quote.Quote.CashPriceDiscounts[i].Name == 'Government Grant') {
                    governmentGrant += this.quote.Quote.CashPriceDiscounts[i].Amount;
                }
            }
            return governmentGrant
        },
        retailPrice() {
            return parseFloat(this.vehicle.price_was);
        },
        cashPrice() {
            return parseFloat(this.quote.Quote.CashPrice || this.retailPrice);
        },
        roadsideAssistance() {
            if (this.error) {
                return 0;
            }
            if (typeof this.quote.Quote.Breakdown == 'undefined' || this.quote.Quote.Breakdown.length == 0) {
                return 0;
            }

            let roadsideAssistance = 0;
            for (let i = 0, len = this.quote.Quote.Breakdown.length; i < len; i++) {
                if (this.quote.Quote.Breakdown[i].Type && this.quote.Quote.Breakdown[i].Type == 'Roadside Assistance') {
                    roadsideAssistance += this.quote.Quote.Breakdown[i].Amount;
                }
            }

            return roadsideAssistance;
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/redesign/variables";

.finance-quote {
    &__quote {
        display: grid;
        grid-template-columns: minmax(0, 2fr) minmax(0, 125px);
        font-size: 16px;
        gap: 5px;
    }

    &__quote-key {
        grid-column: 1 / 2;
        text-align: left;
    }

    &__quote-value {
        grid-column: 2 / 3;
        font-weight: 800;
        text-align: right;
        color: #0E3B85;
    }
}
</style>